import { SelectProps } from "@amzn/awsui-components-react";
import { useMemo } from "react";
import { useFinanceCodesConfig } from "./useCatalogicalConfig";

/**
 * Response interface that represent the finance codes response format
 *
 * @interface
 * @property {string} [key] - Finance code key-value pairs where key is the code identifier and value is the code description
 */
export interface FinanceCodesResponse {
    [key: string]: string;
}

/**
 * Custom hook that fetches finance codes from Catalogical and transforms into select options format
 *
 * @returns {{ options: SelectProps.Options; isLoading: boolean }} Select options and loading state
 */
export const useFinanceCodesForSelect = (): { options: SelectProps.Options; isLoading: boolean } => {
    const { data: codes, isLoading } = useFinanceCodesConfig();

    const options = useMemo(() => {
        if (!codes) return [];
        return Object.entries(codes).map(([key, label]) => ({
            label: label,
            value: key,
        }));
    }, [codes]);

    return { options, isLoading };
};
